import Accordion from 'accordion-js';

let accordion = null;

if (document.readyState === 'complete') {
  // The page is already loaded before this script runs, which means turbo:load won't trigger on this page load. Trigger it manually.
  loaded();
}
document.addEventListener('turbo:load', function () {
  // This event will be fired every time a page is loaded (after the file is included in the document).
  loaded();
});

function loaded() {
  const container = document.querySelector('.accordion-container');
  if (!container) return;

  accordion = new Accordion(container);
  const title = document.querySelector('.faq-category-title');

  const faqCategories = document.querySelectorAll('.faq-category');
  faqCategories.forEach((category) => {
    category.addEventListener('click', function () {
      accordion.closeAll();

      // Reset all other categories
      faqCategories.forEach((c) => {
        c.classList.remove('active');
      });
      // Set this category
      category.classList.add('active');

      window.scrollTo({
        top: container.getBoundingClientRect().top + window.scrollY - 100,
        behavior: 'smooth',
      });

      title.innerHTML = category.innerHTML;

      // Reset all other categories
      const ac = document.querySelectorAll('.accordion-container .ac');
      ac.forEach((a) => {
        a.classList.remove('active');
        a.classList.add('inactive');
      });

      // // Set this category
      const acs = document.querySelectorAll(
        `.accordion-container .ac[data-faq-category-id="${category.dataset.categoryId}"]`
      );

      acs.forEach((a) => {
        a.classList.remove('inactive');
        a.classList.add('active');
      });
    });
  });
}
